// extracted by mini-css-extract-plugin
export default {"place_for_photo":"print_place_for_photo__0g6Vr"};